import React from 'react'

import ArticlesOverview from '../../../react4xp/components/ArticlesOverview'

function ArticlesOverviewPart({title, image, tags, endpoint, startValues, strings}) {
	return (
		<ArticlesOverview
			title={title}
			image={image}
			tags={tags}
			endpoint={endpoint}
			startValues={startValues}
			strings={strings}
		/>
	)
}

export default (props) => <ArticlesOverviewPart {...props} />
